// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "service-Y60eP";
var _3 = "service__icon-3r6Kz";
var _4 = "service__info-1_-nv";
var _5 = "service__name-5QANI";
export { _1 as "__esModule", _2 as "service", _3 as "service__icon", _4 as "service__info", _5 as "service__name" }
export default { "__esModule": _1, "service": _2, "service__icon": _3, "service__info": _4, "service__name": _5 }
